export const CONTENT_URL = "https://contents.irec-stockholm.org/graphql";
